import { tv } from "tailwind-variants";

/**
 * Shared chrome for form fields: the help text below a control and its error
 * counterpart. The control itself brings its own styles (see e.g.
 * `inputStyle`, `comboboxStyle`).
 */
export const fieldStyle = tv({
  slots: {
    description: "text-sm text-muted-foreground",
    error: "text-sm text-destructive",
  },
});
